import { call, put } from "redux-saga/effects";
import { apiGeneral, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { UpdateUserSecondaryEmailActions } from "store/ducks/settings/users";

export function* updateUserSecondaryEmailRequest(action: any) {
  try {
    const { id, putData, onSuccess } = action as IUpdateRequest;
    const { data: responseBody } = yield call(
      apiGeneral.put,
      `/user-email-secondary/${id}`,
      putData
    );

    const { data } = responseBody;
    yield put(UpdateUserSecondaryEmailActions.success(data));
    notify("success", "Email atualizado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(UpdateUserSecondaryEmailActions.failure(errorMessage));
  }
}
